<template>
  <Badge
    class="rebate-badge text--bold"
    :magenta="magenta"
    :white="white"
    :black="black"
    :style="customStyle"
    :bold="bold"
  >
    <span
      v-if="preText"
      class="rebate-badge__pre-text"
      v-html="preText"
    />
    <span class="rebate-badge__text">
      {{ humanizePriceFromCents(defaultPrice) }}
    </span>
    <br />
    <template v-if="wasPrice > 0">
      statt
      <span class="text--strikethrough">{{ humanizePriceFromCents(wasPrice) }}</span>
    </template>
  </Badge>
</template>

<script>
import { Badge } from '@i22/td-longtail-vue-components';
import { humanizePriceFromCents } from '~/lib/price';

export default {
  name: 'RebateBadge',
  components: { Badge },
  props: {
    defaultPrice: {
      type: Number,
      required: true,
    },
    isMagentaTheme: { type: Boolean, default: false },
    preText: { type: String, default: '' },
    wasPrice: {
      type: Number,
      default: 0,
    },
    customStyle: { type: [String, Object], default: undefined },
    black: { type: Boolean },
    magenta: { type: Boolean },
    white: { type: Boolean },
    bold: { type: Boolean },
  },
  methods: { humanizePriceFromCents },
};
</script>

<style lang="scss">
@use 'assets/base' as *;
.rebate-badge {
  .badge__content {
    @include mq($mq-md) {
      font-size: 1.2em;
      line-height: 1.3em;
    }
  }

  &__text {
    font-size: 1.5em;
    line-height: 1em;
  }
}
</style>
